import { invoke } from '@shared/easyfy.decorators';
import { initSlideProductList } from '@webModules/splideHelper';

namespace Easyfy.Components {
  @invoke
  class ProductListComponent {
    static Instance: ProductListComponent;

    constructor() {
      ProductListComponent.Instance = this;
    }

    onInit() {
      ProductListComponent.refreshProductList();

      window.addEventListener('ProductListComponent', ((
        event: CustomEvent
      ) => {
        ProductListComponent.refreshProductList();
      }) as EventListener);
    }

    static refreshProductList = () => {
      document
        .querySelectorAll('[data-container="productlist-scroll"]')
        .forEach((list) => {
          initSlideProductList(list);
        });
    };
  }
}
